let commonUtils = require('../../common_utils');

class LoginHelper {

    //登录后执行的操作
    static afterLogin(vue, data) {
        let that = vue;
        localStorage.clear();
        vue.$store.commit('set', {key: 'token', value: ''});
        window.document.cookie = '';
        if (data.id_acheteur) {
            this._afterBuyerLogin(data, that);
        } else if (data.id_adminuser) {
            this._afterAdminLogin(data, that);
        }
    }

    static _afterBuyerLogin(data, that) {
        localStorage.setItem('token', data.token)
        localStorage.setItem('id_acheteur', data.id_acheteur)
        that.$store.commit('set', {key: 'token', value: data.token})
        if (that.$route.query.redirect) {
            that.$router.replace(decodeURIComponent(that.$route.query.redirect));
        } else {
            that.$router.replace('/homepage')
        }
        that.$api.info.getInfo().then(res => {
            if (res.acheteur) {
                that.$store.commit('set', {key: 'userInfo', value: res.acheteur});
            }
        })
    }

    static async _afterAdminLogin(data, that) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('id_adminuser', data.id_adminuser);
        that.$store.commit('set', {key: 'token', value: data.token});
        that.$store.commit('set', {key: 'userInfo', value: data.user});
        that.$router.replace('/admin/pageImgSet');
    }

    //老站点登录
    static async old_station_connect_login(vue) {
        let that = vue;
        let query = that.$route.query;
        let old_id_token_connection = commonUtils.getCookie('acheteurlogin');
        if ((!query.id_u || !query.connect_token) && !old_id_token_connection) return;
        let params = {
            id_acheteur: query.id_u,
            connect_token: query.connect_token,
            token_connection: old_id_token_connection,
        }
        that.$api.auth.old_station_connect_login(params).then(res => {
            if (res.code !== 0) {
                return;
            }
            let data = res.data;
            LoginHelper.afterLogin(that, data);
        })
    }

    static async logout(vue) {
        let that = vue;
        localStorage.clear();
        that.$store.commit('set', {key: 'token', value: ''});
        window.document.cookie = '';
        commonUtils.delCookie('acheteurlogin');
        that.$router.replace({path: '/'})
    }
}

module.exports = LoginHelper;
